module.exports = __webpack_public_path__ + "toBride2-jp-w-n.56eaacef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toBride2-jp-w-n.jpg
// module id = glyY
// module chunks = 0